<template>
  <div>
    <div class="goodsManageSet">
      <div class="banner">
        <img src="../../assets/images/banner3.png" alt="" />
      </div>
      <div class="breadcrumb flex-rowc">
        <div class="breadcrumb_icon">
          <i class="iconfont icon-shangpinsku"></i>
        </div>
        <div class="breadcrumb_item">物流&订单管理</div>
        <div class="breadcrumb_item_arrow"></div>
        <div class="breadcrumb_item">出库管理</div>
      </div>

      <div class="main_content">
        <div class="tit">发货</div>

        <div class="block">
          <h1><span class="mark">*</span>订单物流状态</h1>
          <div class="radio_box">
            <van-radio-group
              direction="horizontal"
              v-model="formData.runstate"
              style="justify-content: space-evenly"
            >
              <van-radio name="待发货">待发货</van-radio>
              <van-radio name="已发货">已发货 </van-radio>
            </van-radio-group>
          </div>
        </div>
        <div class="block">
          <h1><span class="mark">*</span>物流类型</h1>
          <div class="radio_box">
            <van-radio-group
              direction="horizontal"
              v-model="formData.runname"
              style="justify-content: space-evenly"
            >
              <van-radio
                v-for="(item, index) in logisticsList"
                :key="index"
                :name="item.evalue"
                style="margin-bottom: 10px"
                >{{ item.etext }}</van-radio
              >
            </van-radio-group>
          </div>
        </div>
        <div class="block">
          <h1>发货物流单号</h1>
          <div class="input_box flex-between">
            <van-field
              v-model="formData.runno"
              placeholder="请填写发货物流单号"
            />
          </div>
        </div>
        <div class="block">
          <h1>
            发货门店<span class="mark"
              >“非必填项，如非门店发货，则无需选择”</span
            >
          </h1>
          <div class="input_box flex-between" @click="handleShowPopup(1)">
            <van-field
              v-model="service_shopstr"
              placeholder="请选择发货门店"
              readonly
            />
            <i class="iconfont icon-bottom"></i>
          </div>
        </div>
        <div class="block">
          <!-- <h1>
            库源信息<span class="mark"
              >“非必填项，如无库源信息，则无需选择”</span
            >
          </h1>
          <p v-html="formData.warehouse" class="warehouse"></p> -->
          <!-- <div class="input_box flex-between">
            <van-field
              v-model="formData.warehouse"
              placeholder="请选择库源信息"
            />
          </div> -->
          <!-- <div class="input_box flex-between">
            <van-field
              v-model="warehouseName"
              placeholder="库源信息"
              readonly
            />
          </div> -->
        </div>
      </div>

      <div class="primary-button" @click="query">保存确认</div>

      <div class="primary-button return" @click="handleReturn">
        <i class="iconfont icon-yuyinjiantou"></i>返回
      </div>
    </div>

    <van-popup v-model="isShow" round position="bottom" class="brandPopup">
      <div class="block" v-if="isShowType == 1">
        <van-picker
          ref="picker"
          title="发货门店"
          show-toolbar
          :columns="shopList"
          value-key="shopname"
          @confirm="onConfirm"
          @cancel="isShow = false"
        />
      </div>
    </van-popup>
  </div>
</template>

<script>
import { getShopList, getLogistics, encryptstringview } from "../../api/api";
import { getShopWlserviceDetail, editShopWlservice } from "../../api/shop";
export default {
  name: "outboundDistriWlserviceEdit",
  data() {
    return {
      isShowType: 1,
      isShow: false,
      columns: [],
      formData: {
        id: "",
        orderid: "",
        orderno: "",
        wsid: "",
        goods: "",
        msgtype: "",
        msgman: "",
        msglink: "",
        msgaddr: "",
        runstate: "",
        runname: "",
        runno: "",
        shop: "",
      },
      service_shopstr: "", // 门店名称

      // 门店参数
      shopData: {
        Page: 1,
        PageSize: 100,
        qyguid: "",
      },
      shopList: [], // 门店列表

      // 物流订单
      logisticsList: [],
    };
  },
  created() {
    let { routerList, OPENID, USERINFO } = this.$store.state;
    let { name } = this.$route;

    this.shopData.qyguid = USERINFO.qy ? USERINFO.qy.qyguid : "";

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id, wsid } = JSON.parse(res.jsondata);
        console.log(wsid);
        this.formData.id = id;
        this.getShopWlserviceDetail();
        this.getLogistics();
      } else {
        this.$router.back();
      }
    },

    // 仓库配货列表
    getShopWlserviceDetail() {
      this.loading = true;
      getShopWlserviceDetail({ id: this.formData.id }).then((res) => {
        this.formData.orderid = res.orderid ? res.orderid : "";
        this.formData.orderno = res.orderno ? res.orderno : "";
        this.formData.wsid = res.wsid ? res.wsid : "";
        this.formData.goods = res.goods ? res.goods : "";
        this.formData.msgtype = res.msgtype ? res.msgtype : "";
        this.formData.msgman = res.msgman ? res.msgman : "";
        this.formData.msglink = res.msglink ? res.msglink : "";
        this.formData.msgaddr = res.msgaddr ? res.msgaddr : "";
        this.formData.runstate = res.runstate ? res.runstate : "";
        this.formData.runname = res.runname ? res.runname : "";
        this.formData.runno = res.runno ? res.runno : "";
        this.formData.shop = res.shop ? res.shop : "";
        this.loading = false;
      });
    },
    // 显示弹窗
    handleShowPopup(type) {
      this.isShowType = type;
      if (type == 1) {
        this.getShopList();
      }
      this.isShow = true;
    },
    onConfirm(e) {
      let { isShowType } = this;
      if (isShowType == 1) {
        this.formData.shop = e.shopid;
        this.service_shopstr = e.shopname;
      }

      this.isShow = false;
    },

    // 获取门店
    getShopList() {
      getShopList(this.shopData).then((res) => {
        this.shopList = res;
        // this.shopList = this.shopList.concat(...res);
      });
    },
    // 物流订单类型
    getLogistics() {
      getLogistics().then((res) => {
        this.logisticsList = res;
      });
    },
    // 触底加载更多
    // handleChangePopup() {
    //   const picker = this.$refs.picker;
    //   let { shopList, shopData } = this;
    //   if (
    //     shopList.length - 1 == picker.getIndexes().toString() &&
    //     shopList.length >= shopData.Page * shopData.PageSize
    //   ) {
    //     this.shopData.Page += 1;
    //     this.getShopList();
    //   }
    // },

    // 触发门店
    handleShopList() {
      this.isShow = true;
      this.getShopList();
    },

    // 保存
    query() {
      let { formData } = this;
      if (formData.runstate == "") {
        this.$toast("请选择订单物流状态");
        return;
      }
      if (formData.runname == "") {
        this.$toast("请选择物流类型");
        return;
      }
      if (formData.runno == "") {
        // this.$toast('请填写发货物流单号')
        // return
        this.$dialog
          .confirm({
            message: "物流订单号必须填写，否则不能保存",
            cancelButtonText: "再等等",
            confirmButtonText: "确认",
          })
          .then(() => {
            // this.editLogistics()
          })
          .catch(() => {
            // on cancel
          });
      } else {
        this.editShopWlservice();
      }
    },

    // 发货
    editShopWlservice() {
      let { formData } = this;
      const toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      editShopWlservice(formData).then((res) => {
        if (res.result) {
          toast.clear();
          this.$toast.success(res.message);
          setTimeout(() => {
            this.$router.back();
          }, 1500);
        } else {
          this.$toast.fail(res.message);
        }
      });
    },

    // 返回
    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  padding-bottom: 420px;
  .breadcrumb {
    padding-bottom: 60px;
  }
  .main_content {
    .tit {
      text-align: center;
      font-size: 32px;
      font-weight: bold;
      margin-bottom: 50px;
    }
    .block {
      margin-bottom: 80px;
      h1 {
        text-align: center;
        font-weight: 400;
        margin-bottom: 20px;
        font-size: 30px;
      }
      .item {
        margin-bottom: 50px;
      }
      .input_box,
      .select_box {
        margin-bottom: 30px;
      }
      p {
        font-size: 22px;
        text-align: center;
        &.red {
          color: #ff0012;
        }
      }
      .warehouse {
        width: 560px;
        margin: auto;
        text-align: left;
      }
    }
  }
}
</style>